import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../../errorManage';
import messages from '../../messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getMonitor = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_MONITOR,
      payload: true
    });

    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(`/api/app/Clima_Monitor/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    console.log(resp.data)
    dispatch({
      type: actions.GET_MONITOR,
      payload: {
        monitor: resp.data.Monitor_Encuestas[0],
        encuestaMensual: resp.data.Encuesta_Enviadas_x_Mes_Al_Año[0]
        // monitorLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_MONITOR,
      payload: false
    });
  }
}
